import { render, staticRenderFns } from "./CardWhatWeOffer.vue?vue&type=template&id=30a67a9a&scoped=true&"
import script from "./CardWhatWeOffer.vue?vue&type=script&lang=js&"
export * from "./CardWhatWeOffer.vue?vue&type=script&lang=js&"
import style0 from "./CardWhatWeOffer.vue?vue&type=style&index=0&id=30a67a9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a67a9a",
  null
  
)

export default component.exports